<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 stock-movement-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">
                {{ $t("STOCK_MOVEMENTS.ADD_STOCK_MOVEMENT") }}
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <stock-movement-form
              :loading="loading"
              :stockMovementData="stockMovement"
              :formErrors="formErrors"
              @stockMovementSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import { TYPE_CORRECT } from "@/constants/stockMovements";
import defaultStockMovement from "./defaultStockMovement";
import StockMovementForm from "./partials/StockMovementForm.vue";
import Swal from "sweetalert2";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    StockMovementForm,
  },

  mixins: [alertLeave],

  data() {
    const stockMovement = cloneDeep(defaultStockMovement);
    if (this.$currentUserIsLevelOrganization()) {
      stockMovement.organization = {
        type: "organizations",
        id: this.$currentUserOrganizationId(),
      };
    }
    return {
      stockMovement: stockMovement,
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    goBack() {
      this.$router.push({ name: "List StockMovements" });
    },

    viewStockMovement(stockMovement) {
      this.alertLeave = false;
      this.$router.push({
        name: "View StockMovement",
        params: { id: stockMovement.id },
      });
    },

    async handleSubmit(stockMovement) {
      this.loading = true;
      const stockMovementData = cloneDeep(stockMovement);
      try {
        await this.$store.dispatch("stockMovements/add", stockMovementData);
        const stockMovement = await this.$store.getters[
          "stockMovements/stockMovement"
        ];

        if (stockMovement.movement_type == TYPE_CORRECT) {
          await this.$store.dispatch("products/list", {
            sort: "name",
            filter: {
              warehouse: stockMovement.sourceWarehouse.id,
            },
            page: {
              number: 1,
              size: 999999,
            },
          });

          let warehouseProducts = await this.$store.getters["products/list"];
          warehouseProducts = warehouseProducts.filter(
            (item) => !!item.warehouseProduct
          );
          const stockMovementItemsData = [];
          for (const product of warehouseProducts) {
            stockMovementItemsData.push({
              quantity: product.warehouseProduct.quantity,
              storable: {
                type: "products",
                id: product.id,
              },
            });
          }

          if (stockMovementItemsData.length == 0) {
            this.$notify({
              type: "danger",
              message: this.$t("STOCK_MOVEMENTS.NO_PRODUCT_IN_WAREHOUSE"),
            });
          }

          await this.$store.dispatch("stockMovementItems/bulkCreate", {
            stockMovement: stockMovement.id,
            items: stockMovementItemsData,
          });
        }

        this.$notify({
          type: "success",
          message: this.$t("STOCK_MOVEMENTS.STOCK_MOVEMENT_ADDED"),
        });
        this.viewStockMovement(stockMovement);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
